import { connect } from "react-redux";
import OvChartPanel from "./OvChartPanel";

const mapStateToProps = (state, ownProps) => {
  return {
    loading: state.overview.timeSeries.loading
  };
};

const OvChartPanelContainer = connect(mapStateToProps)(OvChartPanel);

export default OvChartPanelContainer;



// WEBPACK FOOTER //
// ./src/OvChartPanelContainer.js